import { BrowserRouter } from 'react-router-dom';

import { AuthProvider } from './context/AuthContext';
import { RouteList } from './routes';

import { AppContainer } from 'components/ui/app-container';
import { IPublicClientApplication } from '@azure/msal-browser';
import { ModalProvider } from 'context/ModalContext/Modal.context';
import { AppContextProvider } from 'context/AppContext';
import { AchievementFeedbackProvider } from 'context/AchievementFeedbackContext';

type AppProps = {
    pca: IPublicClientApplication;
};

const App = ({ pca }: AppProps) => (
    <BrowserRouter>
        <AuthProvider>
            <ModalProvider>
                <AchievementFeedbackProvider>
                    <AppContextProvider>
                        <AppContainer>
                            <RouteList msalInstance={pca} />
                        </AppContainer>
                    </AppContextProvider>
                </AchievementFeedbackProvider>
            </ModalProvider>
        </AuthProvider>
    </BrowserRouter>
);

export default App;
